import avatar1 from "@assets/avatars/avatar-1.svg";
import avatar2 from "@assets/avatars/avatar-4.svg";
import avatar3 from "@assets/avatars/avatar-5.svg";
import AvatarWithText from "@core-components/avatar-text/AvatarWithText";
import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSHeadLineHeader from "@core-components/title/components/SSHeadLineHeader";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack, Text } from "@mantine/core";
import { Trans } from "react-i18next";
import HomeSearch from "./HomeSearch";

const HomeTitle = () => {
  const { t } = useAppTranslation("pages.home.title");
  return (
    <SSBackgroundImage>
      <SSBgImageHeadline
        header={<SSHeadLineHeader>{t("headline")}</SSHeadLineHeader>}
        subTitle={
          <Stack align="center" className="px-2" gap={10} pt={44}>
            <HomeSearch />
            <AvatarWithText
              avatars={[avatar1, avatar2, avatar3]}
              text={
                <Trans t={t} i18nKey="subTitle">
                  Reconnu par plus de
                  <Text inherit span fw={"bolder"}>
                    {" 5,000+ "}
                  </Text>
                  joueurs.
                </Trans>
              }
            />
          </Stack>
        }
      >
        <Trans t={t} i18nKey="buy">
          <SSWhiteText> ACHETER </SSWhiteText>
          <br />
          <SSLoLGradientText> UN COMPTE LOL </SSLoLGradientText>
        </Trans>
      </SSBgImageHeadline>
    </SSBackgroundImage>
  );
};

export default HomeTitle;
